<script>
import Button from "@/components/reusable/Button.vue";

export default {
  components: {Button},
  props: ['project'],
  methods: {
    goToLink(url) {
      if (url) {
        window.open(url, '_blank'); // 新窗口打开
      }
    }
  }
};
</script>

<template>
  <div
      class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark"
      aria-label="Single Project"
  >
    <div class="flex justify-center items-center">
      <img
          :src="project.img2"
          :alt="project.title"
          class="rounded-t-xl border-none"
      />
    </div>
    <div class="px-4 py-6">
      <p
          class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2"
      >
        {{ project.title }}
      </p>
      <p
          class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light text-left"
      >{{ project.category }}</p
      >
      <p
          class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light mt-5"
      >
        <Button title="点击购买"
                class="buy-button px-4 sm:px-6 py-2 sm:py-2.5 text-white  rounded-md focus:ring-1 duration-500"
                type="submit" @click="goToLink(project.link)" />
      </p
      >
    </div>
  </div>
</template>

<style scoped>
.buy-button{
  background: #fd8c39;
  border-radius: 2rem;
}
</style>
